import {
  ExcelCellValue,
  ParsedSheet,
} from '../UrlExcelMapper/UrlExcelMapper.types'

export const PREVIEW_ROWS_LIMIT = 200

export const PREVIEW_COLUMNS_LIMIT = 60

const normalizeCellValue = (value: unknown): ExcelCellValue => {
  if (value === undefined || value === null) return null
  if (
    typeof value === 'string' ||
    typeof value === 'number' ||
    typeof value === 'boolean'
  )
    return value
  return String(value)
}

export interface ParsedWorkbook {
  sheets: ParsedSheet[]
  rowsTruncated: boolean
  columnsTruncated: boolean
}

export const parseExcelWorkbook = async (
  arrayBuffer: ArrayBuffer
): Promise<ParsedWorkbook> => {
  const XLSX = await import('xlsx')
  const workbook = XLSX.read(arrayBuffer, {
    type: 'array',
    cellDates: true,
    dense: true,
    sheetRows: PREVIEW_ROWS_LIMIT,
    cellStyles: false,
    cellHTML: false,
  })

  let rowsTruncated = false
  let columnsTruncated = false

  const sheets = workbook.SheetNames.map((sheetName, index) => {
    const worksheet = workbook.Sheets[sheetName]
    const ref = worksheet?.['!ref']

    if (!ref) {
      return {
        name: sheetName,
        index,
        maxColumns: 0,
        rows: [],
      }
    }

    const range = XLSX.utils.decode_range(ref)
    range.s.r = 0
    range.s.c = 0

    if (range.e.c >= PREVIEW_COLUMNS_LIMIT) {
      columnsTruncated = true
      range.e.c = PREVIEW_COLUMNS_LIMIT - 1
    }

    const maxColumns = range.e.c + 1
    const rows = XLSX.utils
      .sheet_to_json<unknown[]>(worksheet, {
        header: 1,
        defval: null,
        raw: false,
        range,
      })
      .map((row, rowIndex) => ({
        rowNumber: rowIndex + 1,
        cells: Array.from({ length: maxColumns }, (_, columnIndex) =>
          normalizeCellValue(row[columnIndex])
        ),
      }))

    if (rows.length >= PREVIEW_ROWS_LIMIT) rowsTruncated = true

    return {
      name: sheetName,
      index,
      maxColumns,
      rows,
    }
  })

  return { sheets, rowsTruncated, columnsTruncated }
}
